import Quill from 'quill';
import * as Parchment from 'parchment';

let Inline = Quill.import('blots/inline');
// ===== Custom Inline Math Field Span Blot =====
class MathFieldSpanInlineBlot extends Inline {
    static blotName = 'math-field';
    static tagName = 'span';
    static className = 'math-field';

    static create(value) {
        const node = super.create();
        node.setAttribute('math-field', value);
        node.setAttribute('contenteditable', 'false');
        node.setAttribute('tabindex', '-1');
        node.setAttribute('value', value);
        node.innerText = value;
        return node;
    }

    static formats(node) {
        return node.getAttribute('value');
    }

    format(name, value) {
        if (name === 'math-field' && value) {
            this.domNode.setAttribute('value', value);
        } else {
            super.format(name, value);
        }
    }

    static value(node) {
        return node.getAttribute('value');
    }
}
MathFieldSpanInlineBlot.scope = Parchment.Scope.INLINE;
Quill.register(MathFieldSpanInlineBlot, true);
